import clsx from "clsx";
import { PropsWithChildren } from "react";

interface HdButtonProps {
  type: "button" | "submit";
  variant: "primary" | "secondary" | "accent" | "gray" | "plain";
  size?: "small" | "medium" | "large";
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  onMouseDown?: (e: React.MouseEvent) => void;
  disabled?: boolean;
}

function HdButton(props: PropsWithChildren<HdButtonProps>) {
  const getFontSize = () => {
    switch (props.size) {
      case "small":
        return "12px";
      case "medium":
        return "14px";
      case "large":
        return "16px";
      default:
        return "14px";
    }
  };
  return (
    <button
      type={props.type}
      style={{ fontSize: getFontSize() }}
      className={clsx(
        props.variant === "primary" && "bg-primary",
        props.variant === "accent" && "bg-accent",
        props.variant === "secondary" && "bg-secondary",
        props.variant === "gray" && "bg-gray-200 !text-bodyText",
        props.variant !== "plain" && "text-white rounded-full",
        props.size === "small" && props.variant !== "plain" && "px-3 py-2",
        (props.size == null || props.size === "medium") &&
          props.variant !== "plain" &&
          "px-4 py-2 min-w-36",
        props.size === "large" &&
          props.variant !== "plain" &&
          "px-8 py-4 min-w-36",
        props.disabled && "opacity-70 hover:!opacity-70 !cursor-default",
        "cursor-pointer hover:opacity-90 focus-within:opacity-90 outline-none",
        props.className
      )}
      onClick={props.onClick}
      onMouseDown={props.onMouseDown}
      disabled={props.disabled}
    >
      {props.children}
    </button>
  );
}
export default HdButton;
